import { h, Fragment } from "@stencil/core";
import localI18n from "../../../util/i18n";
import { interval, Subject, takeUntil } from "rxjs";
export class SessionExpiration5MinWarnPopUp {
    constructor() {
        this.open = false;
        this.remainingSessionDisplayTime = '';
        this.remainingSessionDisplayTimeScreenreader = '';
        this.nextWarn = undefined;
        this.firstFocusableElement = undefined;
        this.lastFocusableElement = undefined;
    }
    el;
    remainingSessionTime;
    finished = new Subject();
    async eventListener(event) {
        if (this.checkEvent(event)) {
            this.finished.next(true);
            // Can only display whole seconds
            this.remainingSessionTime = Math.floor(event.detail.msUntilSessionEnd / 1000) * 1000;
            this.formatSessionTimout(this.remainingSessionTime);
            this.startTicker();
            this.open = true;
            this.firstFocusableElement = this.el.shadowRoot.getElementById('session-expiration-5m-warn-popup-close');
            this.lastFocusableElement = this.el.shadowRoot.getElementById('session-expiration-5m-warn-popup-continue-btn');
            await new Promise((resolve) => setTimeout(resolve, 1));
            this.lastFocusableElement.focus();
        }
    }
    handleKeyDown(ev) {
        const tabWasPressed = ev.key === 'Tab';
        const escapeWasPressed = ev.key === 'Escape';
        if (escapeWasPressed) {
            this.handleCloseClick();
        }
        if (!tabWasPressed) {
            return;
        }
        const tabbingForwards = !ev.shiftKey;
        if (tabbingForwards && this.el.shadowRoot.activeElement === this.lastFocusableElement) {
            this.firstFocusableElement.focus();
            ev.preventDefault();
        }
        if (!tabbingForwards && this.el.shadowRoot.activeElement === this.firstFocusableElement) {
            this.lastFocusableElement.focus({ preventScroll: false });
            ev.preventDefault();
        }
    }
    checkEvent(event) {
        return !event.detail.nextWarningMsBeforeSessionEnd && event.detail.msUntilSessionEnd > 0;
    }
    formatSessionTimout(durationInMillis) {
        const durationInSec = durationInMillis / 1000;
        const mins = Math.floor(durationInSec / 60);
        const secs = Math.floor(durationInSec - mins * 60);
        this.remainingSessionDisplayTime = `${this.padTime(mins)} : ${this.padTime(secs)}`;
        this.remainingSessionDisplayTimeScreenreader = `${mins}${localI18n.t('5M_POPUP_SESSION_TIMEOUT_1')}${secs}${localI18n.t('5M_POPUP_SESSION_TIMEOUT_2')}`;
    }
    padTime(time) {
        return String(time).padStart(2, '0');
    }
    startTicker() {
        interval(1000)
            .pipe(takeUntil(this.finished))
            .subscribe((_) => {
            if (this.remainingSessionTime <= 0) {
                this.finished.next(true);
            }
            else {
                this.remainingSessionTime = this.remainingSessionTime - 1000;
                this.formatSessionTimout(this.remainingSessionTime);
            }
        });
    }
    getSessionTimeout() {
        let ms = localI18n.t('5M_POPUP_SESSION_TIMEOUT_3');
        return (
        // @ts-ignore
        h(Fragment, null, h("div", { class: 'd-flex flex-column align-items-center justify-content-center pt-1', "aria-hidden": "true" }, h("span", { class: 'fs-2 timer-text' }, this.remainingSessionDisplayTime), h("p", { class: 'timer-description' }, ms)), h("span", { class: "sr-only" }, this.remainingSessionDisplayTimeScreenreader)));
    }
    handleCloseClick() {
        this.open = false;
        this.finished.next(true);
    }
    render() {
        return (h("div", { key: '1a91301eaa7f0d255f43379c38fa57c449759af9', class: `modal overlay ${this.open ? 'is-visible' : ''}`, id: "popupHL", tabindex: "-1", role: "dialog", "aria-label": localI18n.t('5M_POPUP_1'), "aria-hidden": "false" }, h("div", { key: '1ceb63d39e81c2570db777bc1f2e59310cad41f6', class: "modal-dialog modal-dialog-centered" }, h("div", { key: '655e296275df05097d8c6fb048bfa02235c6b071', class: "modal-content" }, h("div", { key: '5309d24e6a494f3ca48bc92bd4e8e090705a299b', class: "modal-header" }, h("button", { key: '1eb150e1b4fbd038c566492fe1c6a99446eae6ed', id: "session-expiration-5m-warn-popup-close", type: "button", class: "ba-modal-close", "data-bs-dismiss": "modal", "aria-label": localI18n.t('5M_POPUP_2'), title: localI18n.t('5M_POPUP_2'), onClick: () => this.handleCloseClick() }), h("h1", { key: '048a4a0906b7b337c77a87fa25682e519e1749df', class: "modal-title" }, localI18n.t('MIN_5_HEADLINE'))), h("div", { key: 'd53cdb8d12a3a5642523ddd9b9c1a0a5c75612f0', class: "modal-body" }, this.getSessionTimeout(), localI18n.t('MIN_5_INFO')), h("div", { key: '9e7e24840e29684b23dfabff9dfb9b91a82c78c2', class: "modal-footer" }, h("button", { key: '02618b9b9e4f380d0d14296894e2cb1768da81ee', id: "session-expiration-5m-warn-popup-continue-btn", onClick: () => this.handleCloseClick(), class: "ba-btn ba-btn-primary", type: "button" }, localI18n.t('MIN_5_BUTTON')))))));
    }
    static get is() { return "session-expiration-5m-warn-popup"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["session-expiration-5m-warn-popup.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["session-expiration-5m-warn-popup.css"]
        };
    }
    static get states() {
        return {
            "open": {},
            "remainingSessionDisplayTime": {},
            "remainingSessionDisplayTimeScreenreader": {},
            "nextWarn": {},
            "firstFocusableElement": {},
            "lastFocusableElement": {}
        };
    }
    static get elementRef() { return "el"; }
    static get listeners() {
        return [{
                "name": "oiamMaxSessionExpirationWarnEvent",
                "method": "eventListener",
                "target": "window",
                "capture": false,
                "passive": false
            }, {
                "name": "keydown",
                "method": "handleKeyDown",
                "target": "window",
                "capture": false,
                "passive": false
            }];
    }
}
